// extracted by mini-css-extract-plugin
module.exports = {"countryBlock":"CountryPhones_countryBlock__2_RoL","widthCountryBlock":"CountryPhones_widthCountryBlock__CdaVR"};